import { TextField } from "@mui/material";

interface FirstNameInputProps {
  disabled?: boolean;
  required?: boolean;
  firstName: string;
  showValidation?: boolean;
  onBlur?: () => void;
  setFirstName?: (firstName: string) => void;
}

const FirstNameInput = ({
  disabled,
  required,
  firstName,
  setFirstName,
  showValidation = true,
  onBlur,
}: FirstNameInputProps): React.JSX.Element => {
  const isInvalid = firstName.length === 0;
  const showError = showValidation && isInvalid;

  return (
    <TextField
      sx={{
        "& .MuiInputBase-root": {
          color: showError
            ? (theme) => theme.palette.error.main
            : isInvalid
              ? undefined
              : (theme) => theme.palette.success.main,
        },
      }}
      disabled={disabled}
      focused={firstName.length > 0}
      color="success"
      required={required}
      fullWidth
      type="text"
      id="FirstNameInput"
      label="Vorname"
      variant="outlined"
      value={firstName}
      onChange={(e) => {
        if (setFirstName) {
          setFirstName(e.target.value);
        }
      }}
      onBlur={onBlur}
      error={showError}
      helperText={showError ? "Bitte gib deinen Vornamen ein" : ""}
    />
  );
};

export default FirstNameInput;
